import { render, staticRenderFns } from "./blog-vs-telegram.vue?vue&type=template&id=db0c4026&scoped=true"
import script from "./blog-vs-telegram.vue?vue&type=script&lang=js"
export * from "./blog-vs-telegram.vue?vue&type=script&lang=js"
import style0 from "./blog-vs-telegram.vue?vue&type=style&index=0&id=db0c4026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0c4026",
  null
  
)

export default component.exports